<template>
	<nav class="Breadcrumb" >
		<ul>
			<li v-for="crumb in crumbs" ><router-link :to="crumb.to" >{{ crumb.text }}</router-link></li>
		</ul>
	</nav>
</template>

<script>

	export default {
		props : [
			'crumbs',
		],
	}

</script>